// Pantalla de inscripciones cerradas del formulario rediseñado (v2).
// Se muestra cuando el periodo (Per_Ins) ya venció; el mensaje va en texto y no dentro de la imagen.
import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import LockIcon from "@material-ui/icons/Lock";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import LanguageIcon from "@material-ui/icons/Language";
import emma_logo from "../../../global/imagenes/logo_agrupado_sinfondo.png";
import emma from "../../../global/imagenes/nueva_emma.png";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { PieInscripcion } from "./componentesInscripcion";

const CORREO_CONTACTO = "preuniversitario@cuc.edu.co";

export default function PantallaCierre({ linkPolitica }) {
  const classes = useEstilosInscripcion();
  return (
    <div className={classes.raiz}>
      <CssBaseline />
      <main className={`${classes.pagina} ${classes.cierrePagina}`}>
        <div className={`${classes.contenedor} ${classes.cierreContenedor}`}>
          <div className={classes.cabecera}>
            <div className={classes.marca}>
              <img src={emma_logo} alt="Logo Emma" className={classes.logoCabecera} />
              <span className={classes.separador} />
              <div>
                <p className={classes.titulo}>Inscripciones Unicosta</p>
                <p className={classes.subtitulo}>PREGRADO</p>
              </div>
            </div>
          </div>

          <div className={classes.cierreCuerpo}>
            <div className={classes.cierreImagen}>
              <img src={emma} alt="Emma" />
            </div>
            <div>
              <span className={classes.cierreEtiqueta}>
                <LockIcon style={{ fontSize: 14 }} />Inscripciones cerradas
              </span>
              <p className={classes.cierreTitulo}>El proceso de inscripción para el periodo actual ha finalizado</p>
              <p className={classes.cierreTexto}>
                Gracias por tu interés en la Universidad de la Costa. Te invitamos a estar atento a la apertura del próximo periodo.
              </p>
              <div className={classes.cierreContacto}>
                <p className={classes.cierreContactoTitulo}>¿Tienes alguna inquietud?</p>
                <p className={classes.cierreContactoDato}>
                  <MailOutlineIcon className={classes.seccionIcono} style={{ fontSize: 16 }} />{CORREO_CONTACTO}
                </p>
              </div>
              <div className={classes.cierreAcciones}>
                <Button className={classes.botonPrincipal} startIcon={<MailOutlineIcon />} href={`mailto:${CORREO_CONTACTO}`}>
                  Escríbenos
                </Button>
                <Button className={classes.botonSecundario} startIcon={<LanguageIcon />} href="https://www.cuc.edu.co/" target="_blank" rel="noopener noreferrer">
                  Ir a cuc.edu.co
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <PieInscripcion linkPolitica={linkPolitica} />
    </div>
  );
}
